import { BaseButton } from './base-button';

export class RemoveButton extends BaseButton {
  constructor() {
    super();
  }

  attached() {}
}
